import { Dialog, DialogContent, DialogTitle, IconButton } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { useTranslation } from 'react-i18next';
import { EmployeeNotasFiscaisManager } from './EmployeeNotasFiscaisManager';

export interface EmployeeNotasFiscaisDialogProps {
  open: boolean;
  employeeId: number | null;
  employeeName?: string;
  onClose: () => void;
}

export function EmployeeNotasFiscaisDialog({
  open,
  employeeId,
  employeeName,
  onClose,
}: EmployeeNotasFiscaisDialogProps): JSX.Element {
  const { t } = useTranslation();

  return (
    <Dialog open={open} onClose={onClose} maxWidth="lg" fullWidth>
      <DialogTitle sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        {employeeName
          ? t('features.colaboradores.notasFiscais.dialogTitleNamed', { nome: employeeName })
          : t('features.colaboradores.notasFiscais.dialogTitle')}
        <IconButton onClick={onClose} aria-label={t('common.close')} size="small">
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent dividers>
        {employeeId !== null && <EmployeeNotasFiscaisManager employeeId={employeeId} />}
      </DialogContent>
    </Dialog>
  );
}
